import { render, staticRenderFns } from "./AutoCrud.vue?vue&type=template&id=01dc3d7a&"
import script from "./AutoCrud.vue?vue&type=script&lang=js&"
export * from "./AutoCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports